<!--
 - Author : wanghongling.
 - Date   : 2019/5/27.
 - File   : layer.通用漂浮层
 -->

<template>
  <div class="layer-wrap" :style="{width: width, padding: padding}">
    <div :class="['layer-wrap-title', titleClass?'titleClass':'']" v-if="title">
      {{title}}
      <img src="../assets/images/shitang/more.png" style="float: right;cursor: pointer;" v-if="showMoreTag" @click="showMore">
    </div>
    <div class="layer-wrap-content" :style="{padding: contPadding}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layer',
  data () {
    return {
    }
  },
  props: {
    title: {
      type: String,
      default: '最新预警'
    },
    width: {
      type: String,
      default: '300px'
    },
    padding: {
      type: String,
      default: '15px 20px'
    },
    contPadding: {
      type: String,
      default: '10px 0'
    },
    showMoreTag: {
      type: Boolean,
      default: false
    },
    titleClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * 显示更多
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    showMore () {
      this.$emit('showMore')
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  .layer-wrap{
    border-radius: 10px;
    background: rgba(0,3,6,0.7);
    /*padding: 15px 20px;*/
    text-align: left;
    min-width: 300px;
    &-title{
      font-size: 20px;
      font-weight: 600;
      color: #fff;
    }
    &-content{
      padding: 10px 0;
    }
    .titleClass{
      font-size: 18px;
      font-weight: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layer.vue